<!-- 创建题目 -->
<template>
  <div class="addExam" v-loading="loading">
    <el-form
      ref="oneForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      label-position="left"
    >
      <!-- @keyup.native.enter="onAction('保存并继续')" -->
      <el-form-item label="题库名称:" prop="exambankValue">
        <el-select
          v-model="ruleForm.exambankValue"
          class="select"
          placeholder="请选择"
          :disabled="selectDisable"
        >
          <template v-for="item in examBankList">
            <el-option :key="item.bank_id" :label="item.bank_name" :value="item.bank_id" />
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="题目类型:" prop="question_type">
        <el-radio-group v-model="ruleForm.question_type">
          <el-radio :label="1">单选</el-radio>
          <el-radio :label="2">多选</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="题目标题:" prop="question_name">
        <el-input
          v-model.trim="ruleForm.question_name"
          placeholder="请输入"
          maxlength="128"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="题目选项:" prop="question_options">
        <el-form id="sortable" label-width="20px" label-position="left">
          <template v-for="(item, index) in ruleForm.question_options">
            <el-form-item class="sortable_item" :label="index | filterLetters(':')" :key="index">
              <div class="input_line">
                <el-input
                  v-model.trim="item.option_content"
                  placeholder="请输入"
                  maxlength="128"
                  show-word-limit
                  clearable
                ></el-input>
                <el-link
                  v-if="index > 1"
                  class="del_text"
                  type="primary"
                  :underline="false"
                  @click="delOptions(index)"
                >
                  删除
                </el-link>
              </div>
              <div class="upload_line">
                <el-upload
                  class="avatar-uploader"
                  :show-file-list="false"
                  action="#"
                  :before-upload="beforeAvatarUpload"
                  :http-request="(data) => httpRequest(data, index)"
                >
                  <img v-if="item.pic_url" :src="item.pic_url" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="color: #2f96ff"></i>
                  <div v-show="item.pic_url" class="del_img" @click.stop="delImgFun(index)">
                    删除
                  </div>
                </el-upload>
                <div class="img_text">
                  上传图片的最佳尺寸300px*300px，且支持png、jpeg、jpg、gif格式，大小不超过1M
                </div>
              </div>
            </el-form-item>
          </template>
          <el-link
            v-if="ruleForm.question_options.length < 10"
            type="primary"
            :underline="false"
            @click="addOptions"
          >
            新增选项
          </el-link>
        </el-form>
      </el-form-item>
      <el-form-item v-if="ruleForm.question_type === 1" label="题目答案:" prop="answerRadio">
        <el-radio-group v-model="ruleForm.answerRadio">
          <el-radio
            v-for="(item, index) in ruleForm.question_options"
            :key="index | filterLetters"
            :label="index | filterLetters"
          ></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="ruleForm.question_type === 2" label="题目答案:" prop="answerCheckbox">
        <el-checkbox-group v-model="ruleForm.answerCheckbox">
          <el-checkbox
            v-for="(item, index) in ruleForm.question_options"
            :key="index | filterLetters"
            :label="index | filterLetters"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="题目解析:" prop="question_analyse">
        <el-input
          v-model.trim="ruleForm.question_analyse"
          placeholder="请输入"
          maxlength="256"
          show-word-limit
          clearable
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="action_line">
      <el-button @click="onAction('取消')">取消</el-button>
      <el-button type="primary" @click="onAction('保存')">保存</el-button>
      <el-button type="primary" @click="onAction('保存并继续')" v-if="!question_id">
        保存并继续
      </el-button>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import { CosMixin } from '@/mixins/cos';
import {
  GetQuestionBankList,
  GetQuestionDetailById,
  CreateQuestion,
  UpdateQuestion,
} from '@/api/examBankManagement';
// 表单初始参数
const ruleFormInit = {
  exambankValue: '', // 题库id
  question_type: 1, // 类型
  question_name: '', // 标题
  // 选项
  question_options: [
    { option_content: '', pic_url: '' },
    { option_content: '', pic_url: '' },
  ],
  answerRadio: 'A', // 单选
  answerCheckbox: ['A', 'B'], // 多选
  question_analyse: '', // 解析
};
export default {
  name: 'AddExam',
  components: {},
  filters: {
    /**
     * @description: 索引转26个字母 0对应A, 25对应Z
     * @param {*} i 索引
     * @param {*} str 拼接字符串 eg: A: xxx 这种格式, 需要拼接':'
     * @return {*}
     */
    filterLetters(i, str) {
      if (i >= 0 && i <= 25) {
        if (str) {
          return String.fromCharCode(65 + i) + str;
        }
        return String.fromCharCode(65 + i);
      }
      return undefined;
    },
  },
  mixins: [CosMixin],
  props: {},
  data() {
    return {
      rules: {
        exambankValue: [{ required: true, message: '必填项', trigger: 'change' }],
        question_type: [{ required: true, message: '必填项', trigger: 'change' }],
        question_name: [{ required: true, message: '必填项', trigger: 'blur' }],
        question_options: [{ required: true, message: '必填项', trigger: 'change' }],
        answerRadio: [{ required: true, message: '必填项', trigger: 'change' }],
        answerCheckbox: [
          {
            required: true,
            type: 'array',
            validator: (rule, value, callback) => {
              console.log(rule);
              if (value.length < 2) {
                callback('至少勾选两个(包括两个)以上的选项');
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        question_analyse: [{ required: false, message: '', trigger: 'blur' }],
      },
      ruleForm: JSON.parse(JSON.stringify(ruleFormInit)),
      examBankList: [], // 题库列表
      selectDisable: false, // 是否禁用下拉选项
      uploadPercent: 0, // 上传进度
      loading: false, // 表单加载
    };
  },
  computed: {
    // 题库id
    bank_id() {
      return Number(this.$route.query.bank_id);
    },
    // 题目id
    question_id() {
      return this.$route.query.question_id;
    },
    // 监听缓存题库id, 如重置需要 上传需要
    computedExambankId() {
      return this.ruleForm.exambankValue;
    },
  },
  watch: {
    // 编辑模式下这两个参数可能无参
    // 'ruleForm.question_type': {
    //   handler(newVal, oldVal) {
    //     console.log(newVal, oldVal);
    //     if (newVal === 1 && !this.ruleForm.answerRadio) {
    //       this.ruleForm.answerRadio = 'A';
    //     } else if (newVal === 2 && !this.ruleForm.answerCheckbox) {
    //       this.ruleForm.answerCheckbox = ['A', 'B'];
    //     }
    //   },
    //   deep: true,
    // },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // this.sortableFun();
  },
  methods: {
    // 初始化
    init() {
      this.setBreadcrumb();
      this.getExamBankList();
      // 题目入口(已确定题库)
      if (this.bank_id) {
        this.selectDisable = true;
        this.ruleForm.exambankValue = this.bank_id; // 赋值题库id
      }
      // 题库入口(详情-编辑)
      if (this.question_id) {
        this.getData();
      }
    },
    // 设置面包屑
    setBreadcrumb() {
      let breadcrumb = [];
      if (this.bank_id) {
        breadcrumb = [
          { menu_name: '考试管理', menu_path: '' },
          { menu_name: '题库管理', menu_path: 'examBankManagement' },
          {
            menu_name: '进入题目列表',
            menu_path: 'detailExamBank',
            menu_params: { bank_id: this.bank_id },
          },
          { menu_name: this.question_id ? '编辑题目' : '创建题目' },
        ];
      } else {
        breadcrumb = [
          { menu_name: '考试管理', menu_path: '' },
          { menu_name: '题库管理', menu_path: 'examBankManagement' },
          { menu_name: '创建题目' },
        ];
      }
      this.$store.commit('user/setBreadcrumb', breadcrumb);
    },
    // 获取题库列表
    async getExamBankList() {
      const res = await GetQuestionBankList({
        page_index: 1, // 分页码
        page_size: 999999, // 每页条数
      });
      this.examBankList = res.bank_list;
    },
    // 获取题目详情
    async getData() {
      this.loading = true;
      try {
        const { question_detail: questionDetail } = await GetQuestionDetailById({
          question_id: [Number(this.question_id)],
        });
        const ruleForm = questionDetail[0];
        // 选题类型对应答案解析
        if (questionDetail[0].question_type === 1) {
          const questionAnswerer = ruleForm.question_answerer[0];
          ruleForm.answerRadio = questionAnswerer;
          ruleForm.answerCheckbox = ['A', 'B'];
        } else {
          ruleForm.answerRadio = 'A';
          ruleForm.answerCheckbox = questionDetail[0].question_answerer;
        }
        ruleForm.exambankValue = this.bank_id; // 赋值题库id
        this.ruleForm = ruleForm;
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },
    // 上传前处理
    beforeAvatarUpload(file) {
      let isSupport = true;
      const regExp = 'PNG|JPG|JPEG|GIF';
      if (!new RegExp(`(${regExp})`, 'i').test(file.type)) {
        this.$message.error(`上传图片仅支持${regExp}格式!`);
        isSupport = false;
      }
      const isSize = file.size / 1024 / 1024 < 1;
      if (!isSize) {
        this.$message.error('上传图片大小不能超过1MB!');
      }
      const success = isSize && isSupport;
      return success;
    },
    // 请求处理
    async httpRequest(data, index) {
      const url = await this.getCosUrl(data);
      this.ruleForm.question_options[index].pic_url = url;
    },
    // 新增选项
    addOptions() {
      if (this.ruleForm.question_options.length >= 10) {
        this.$message.info('最多新增10个选项');
        return;
      }
      this.ruleForm.question_options.push({ option_content: '', pic_url: '' });
    },
    // 删除选项
    delOptions(i) {
      // 单选多选对应状态删除
      if (this.ruleForm.question_type === 1) {
        this.ruleForm.answerRadio = ['A'];
      } else if (this.ruleForm.question_type === 2) {
        this.ruleForm.answerCheckbox = ['A', 'B'];
      }
      this.ruleForm.question_options.splice(i, 1);
    },
    // 删除图片
    delImgFun(i) {
      this.ruleForm.question_options[i].pic_url = '';
    },
    // 表单校验
    checkForm() {
      return new Promise((resolve, reject) => {
        let boolean = true;
        this.$refs.oneForm.validate((valid) => {
          if (valid) {
            for (let i = 0; i < this.ruleForm.question_options.length; i++) {
              const e = this.ruleForm.question_options[i];
              if (!e.option_content && !e.pic_url) {
                this.$message.warning(
                  `选项${this.$options.filters.filterLetters(i)}请输入文字或上传图片`,
                );
                boolean = false;
                return;
              }
            }
          } else {
            boolean = false;
          }
        });
        boolean ? resolve() : reject();
      });
    },
    // 重置表单
    resetForm() {
      const ruleForm = {
        ...JSON.parse(JSON.stringify(ruleFormInit)),
        exambankValue: this.computedExambankId, // 题库id值
      };
      this.ruleForm = ruleForm;
    },
    // 提交/取消操作
    onAction(e) {
      switch (e) {
        case '取消':
          this.$router.go(-1);
          break;
        case '保存':
          this.checkForm().then(async () => {
            this.loading = true;
            const flag = await this.saveData();
            this.loading = false;
            flag ? this.$router.go(-1) : '';
          });
          break;
        case '保存并继续':
          this.checkForm().then(async () => {
            this.loading = true;
            const flag = await this.saveData();
            this.loading = false;
            if (flag) {
              this.resetForm();
              //   this.$refs.oneForm.resetFields();
            }
          });
          break;
        default:
          break;
      }
    },
    // 保存数据
    async saveData() {
      const ruleForm = { ...this.ruleForm };
      // 答案转后端需要的数据
      if (ruleForm.question_type === 1) {
        ruleForm.question_answerer = [ruleForm.answerRadio];
      } else if (ruleForm.question_type === 2) {
        ruleForm.question_answerer = ruleForm.answerCheckbox;
      }
      delete ruleForm.answerRadio;
      delete ruleForm.answerCheckbox;
      delete ruleForm.exambankValue;
      // 选项转后端需要的数据
      ruleForm.question_options.forEach((e, i) => {
        // option_label // 选项名称，示例：A，B，C
        e.option_label = this.$options.filters.filterLetters(i);
        // option_type  // 选项内容类型，1-文字；2-图片 3-文字+图片
        if (e.option_content && e.pic_url) {
          e.option_type = 3;
        } else if (e.pic_url) {
          e.option_type = 2;
        } else if (e.option_content) {
          e.option_type = 1;
        }
      });
      if (ruleForm.question_id) {
        try {
          await UpdateQuestion({
            bank_id: this.computedExambankId,
            question_detail: { ...ruleForm },
          });
          this.$message.success('保存成功');
          return true;
        } catch (error) {
          this.$message.error(error.message);
        }
      } else {
        try {
          await CreateQuestion({
            bank_id: this.computedExambankId,
            question_detail: { ...ruleForm },
          });
          this.$message.success('保存成功');
          return true;
        } catch (error) {
          this.$message.error(error.message);
        }
        return false;
      }
    },
    // 上传转换获取cos地址
    getCosUrl(e) {
      const uploadMsg = this.$message({
        message: `正在上传`,
        iconClass: 'el-icon-loading',
        duration: 0,
      });
      return new Promise(async (resolve, reject) => {
        // 准备上传和上传失败可再上传
        const cosParams = {
          fileObject: e.file,
        };
        try {
          const res = await this.putCosObject(cosParams, undefined, this.uploadProgress);
          uploadMsg.close();
          this.$message.success('上传成功');
          resolve(res.data);
        } catch (error) {
          uploadMsg.close();
          this.$message.error('COS服务器连接失败');
          reject(error);
        }
      });
    },
    // 上传进度 percent(0 - 1 ,如百分之50是0.50， 显示需要乘100)
    uploadProgress(progressData) {
      this.uploadPercent = progressData.percent * 100;
    },
    // 拖拽排序
    sortableFun() {
      const _this = this;
      let scrollTopTemp = 0;
      Sortable.create(document.getElementById('sortable'), {
        animation: 1000,
        draggable: '.sortable_item',
        ghostClass: 'sortable_move',
        dragClass: 'sortable_move',
        // 开始拖拽
        onStart() {
          scrollTopTemp = document.getElementsByTagName('main')[0].scrollTop;
        },
        // 拖动结束
        onEnd({ newIndex, oldIndex }) {
          const temp = [..._this.ruleForm.question_options];
          const oldValue = temp.splice(oldIndex, 1); // 取旧值
          temp.splice(newIndex, 0, oldValue[0]); // 添加到新位置
          _this.ruleForm.question_options = [];
          _this.$nextTick(() => {
            _this.ruleForm.question_options = temp;
            _this.$nextTick(() => {
              document.getElementsByTagName('main')[0].scrollTop = scrollTopTemp; // 还原滚动条位置
            });
          });
        },
      });
    },
  },
};
</script>

<style>
.avatar-uploader {
  position: relative;
  line-height: 0px;
}

.avatar-uploader .el-upload {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.del_img {
  position: absolute;
  bottom: 0;
  left: 0;
  display: inline-block;
  width: 100%;
  line-height: 30px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.65);
  text-align: center;
}
.del_img:hover {
  background-color: #000;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>

<style lang="scss" scoped>
.addExam {
  width: 60%;
  .input_line {
    display: flex;
    .del_text {
      margin-left: 10px;
      width: 35px;
    }
  }
  .upload_line {
    display: flex;
    align-items: flex-end;
    padding: 10px 0 15px 0;
    .img_text {
      display: inline-block;
      font-size: 12px;
      color: #939599;
      line-height: 20px;
      width: 200px;
      margin-left: 10px;
    }
  }
  .action_line {
    padding-top: 40px;
  }
  .sortable_item {
    // cursor: move;
  }
  .sortable_move {
    box-sizing: border-box;
    border: 1px dashed #2f96ff;
    border-radius: 6px;
    padding: 1px 1px 0 1px;
    margin-bottom: 1px;
  }
}
</style>
